import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';
import { rowMonitoringBySubject, rowMonitoringBySubjectCode, rowNewApplication, rowPortfolioEnq } from "./const-xml-format/row-template-xml";
import { enquiredData, applicationCode, matchedSubject, contractsHistory, accountReceivables, subjectAdditionalInfo, negativeEvents, footPrints, scoreData, enquiredDataB2b, matchedSubjectB2b, messageResponse } from './class';
const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/finance/finance_clicks`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

async function filterExportLi(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return await axios.get(`${url}/finance/finance_clicks`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function list_b2b(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/finance/finance_click_b2bs`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

async function filterExportLc(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return await axios.get(`${url}/finance/finance_click_b2bs`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}


async function add(data) {
  data.type = 'finance_clicks'
  // console.log(data);
  const payload = jsona.serialize({
    stuff: data,
    includeNames: null
  });
  // console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/finance/finance_clicks/way/newapp`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

async function addB2b(data) {
  data.type = 'finance_click_b2bs'
  // console.log(data);
  const payload = jsona.serialize({
    stuff: data,
    includeNames: null
  });
  // console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/finance/finance_click_b2bs/way/newappb2b`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}


async function postNewApplication(data, save) {

  // const getDataField = rowNewApplication(data.purposeOfEnq, data.gender, data.marriageStatus ?? '', data.educationalStatusCode ?? '', data.nameAsId, data.fullName ?? '', data.motherName ?? '', data.birthDate, data.birthPlace ?? '', data.address, data.subDistrict, data.district, data.city, data.postalCode, data.country, data.identityType, data.identityNumber, data.npwp ?? '', data.phoneNumber ?? '', data.cellphoneNumber, data.emailAddress ?? '', data.resident ?? '', data.occupation ?? '', data.workplace ?? '', data.employerSelector ?? '', data.workplaceAddress ?? '', data.roleInApplication, data.dueDate ?? '', data.applicationAmount, data.contractType, data.currency, data.originalAgreementNumber ?? '', data.originalAgreementDate ?? '');

  // let dataRes = ax.post('/api/create-newapp', { data: getDataField }).then(res => {
  //   return res;
  // });
  // console.log(dataRes);
  // return dataRes;

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },

  };

  return axios.post(`${url}/finance/finance_clicks/way/create-newapp`, data, options)
    .then(res => {
      // return jsona.deserialize(response.data);
      // console.log(res.data);
      let parsing = new DOMParser();
      let xmlDom = parsing.parseFromString(res.data, "text/xml");
      // console.log(xmlDom)

      const rootErr = xmlDom.getElementsByTagName('cb:CB_NAE_ProductOutput')[0];
      const err = rootErr.getElementsByTagName('cb:Error')[0];
      const errDes = err?.attributes?.Description?.value ?? ''

      if (err) {
        // console.log(errDes);
        return { error: true, messageErr: errDes };
      }

      let messageRes = messageResponse(xmlDom);
      let enqData = enquiredData(xmlDom)
      let appCodeData = applicationCode(xmlDom)
      let matchedSubData = matchedSubject(xmlDom)
      let contractsHistoryData = contractsHistory(xmlDom)
      let accountReceivablesData = accountReceivables(xmlDom)
      let subjectAdditionalInfoData = subjectAdditionalInfo(xmlDom)
      let negativeEventsData = negativeEvents(xmlDom)
      let footPrintsData = footPrints(xmlDom)
      let scoreDataData = scoreData(xmlDom)

      let dataConvert = {
        messageRes,
        enqData,
        appCodeData,
        matchedSubData,
        contractsHistoryData,
        accountReceivablesData,
        subjectAdditionalInfoData,
        negativeEventsData,
        footPrintsData,
        scoreDataData,
      }
      if (save) {
        if (dataConvert.matchedSubData.FlagMatched !== '0') {
          // console.log('OKEH', dataConvert);
          this.dialog = true
          this.resultsDataXml = dataConvert;
          // console.log({ ...enqData, StatusEnq: '1', PurposeOfEnq: data.purposeOfEnq, Resident: data.resident, Occupation: data.occupation, Workplace: data.workPlace, EmployerSelector: data.employerSelector, WorkplaceAddress: data.workPlaceAddress, RoleInApplication: data.roleInApplication, DueDate: data.dueDate, ApplicationAmount: data.applicationAmount, ContractType: data.contractType, Currency: data.currency, OriginalAgreementNumber: data.originalAgreementNumber, OriginalAgreementDate: data.originalAgreementDate })
          // axios.post('http://127.0.0.1:8000/api/newapp', { ...enqData, StatusEnq: '1', PurposeOfEnq: data.purposeOfEnq, Resident: data.resident, Occupation: data.occupation, Workplace: data.workPlace, EmployerSelector: data.employerSelector, WorkplaceAddress: data.workPlaceAddress, RoleInApplication: data.roleInApplication, DueDate: data.dueDate, ApplicationAmount: data.applicationAmount, ContractType: data.contractType, Currency: data.currency, OriginalAgreementNumber: data.originalAgreementNumber, OriginalAgreementDate: data.originalAgreementDate }).then(res => {
          //   console.log(res);
          // }).catch(e => {
          //   alert(e);
          // })
          add(camelCaseKeysToUnderscore({ ...enqData, StatusEnq: '1', PurposeOfEnq: data.purposeOfEnq, IdMessage: data.idMessage, Resident: data.resident, Occupation: data.occupation, Workplace: data.workPlace, EmployerSelector: data.employerSelector, WorkplaceAddress: data.workPlaceAddress, RoleInApplication: data.roleInApplication, DueDate: data.dueDate, ApplicationAmount: data.applicationAmount, ContractType: data.contractType, Currency: data.currency, OriginalAgreementNumber: data.originalAgreementNumber, OriginalAgreementDate: data.originalAgreementDate, XmlData: res.data }))
        } else {
          // console.log('FAILED', dataConvert);
          this.dialog = true
          this.resultsDataXml = dataConvert;
          add(camelCaseKeysToUnderscore({ ...enqData, StatusEnq: '0', PurposeOfEnq: data.purposeOfEnq, IdMessage: data.idMessage, Resident: data.resident, Occupation: data.occupation, Workplace: data.workPlace, EmployerSelector: data.employerSelector, WorkplaceAddress: data.workPlaceAddress, RoleInApplication: data.roleInApplication, DueDate: data.dueDate, ApplicationAmount: data.applicationAmount, ContractType: data.contractType, Currency: data.currency, OriginalAgreementNumber: data.originalAgreementNumber, OriginalAgreementDate: data.originalAgreementDate, XmlData: res.data }))
          // console.log({ ...enqData, StatusEnq: '0', PurposeOfEnq: data.purposeOfEnq, Resident: data.resident, Occupation: data.occupation, Workplace: data.workPlace, EmployerSelector: data.employerSelector, WorkplaceAddress: data.workPlaceAddress, RoleInApplication: data.roleInApplication, DueDate: data.dueDate, ApplicationAmount: data.applicationAmount, ContractType: data.contractType, Currency: data.currency, OriginalAgreementNumber: data.originalAgreementNumber, OriginalAgreementDate: data.originalAgreementDate })
          // axios.post('http://127.0.0.1:8000/api/newapp', { ...enqData, StatusEnq: '0', PurposeOfEnq: data.purposeOfEnq, Resident: data.resident, Occupation: data.occupation, Workplace: data.workPlace, EmployerSelector: data.employerSelector, WorkplaceAddress: data.workPlaceAddress, RoleInApplication: data.roleInApplication, DueDate: data.dueDate, ApplicationAmount: data.applicationAmount, ContractType: data.contractType, Currency: data.currency, OriginalAgreementNumber: data.originalAgreementNumber, OriginalAgreementDate: data.originalAgreementDate }).then(res => {
          //   console.log(res);
          // }).catch(e => {
          //   alert(e);
          // })
        }
      }

      return dataConvert;
    });
}

async function postNewApplicationB2b(data, save) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios.post(`${url}/finance/finance_click_b2bs/way/create-newappb2b`, data, options)
    .then(res => {
      // console.log(res.data);
      let parsing = new DOMParser();
      let xmlDom = parsing.parseFromString(res.data, "text/xml");
      // console.log(xmlDom)

      const rootErr = xmlDom.getElementsByTagName('cb:CB_NAE_ProductOutput')[0];
      const err = rootErr.getElementsByTagName('cb:Error')[0];
      const errDes = err?.attributes?.Description?.value ?? ''

      if (err) {
        // console.log(errDes);
        return { error: true, messageErr: errDes };
      }

      let messageRes = messageResponse(xmlDom);
      let enqData = enquiredDataB2b(xmlDom)
      let appCodeData = applicationCode(xmlDom)
      let matchedSubData = matchedSubjectB2b(xmlDom)
      let contractsHistoryData = contractsHistory(xmlDom)
      let accountReceivablesData = accountReceivables(xmlDom)
      let subjectAdditionalInfoData = subjectAdditionalInfo(xmlDom)
      let negativeEventsData = negativeEvents(xmlDom)
      let footPrintsData = footPrints(xmlDom)
      let scoreDataData = scoreData(xmlDom)

      let dataConvert = {
        messageRes,
        enqData,
        appCodeData,
        matchedSubData,
        contractsHistoryData,
        accountReceivablesData,
        subjectAdditionalInfoData,
        negativeEventsData,
        footPrintsData,
        scoreDataData,
      }
      if (save) {
        if (dataConvert.matchedSubData.FlagMatched !== '0') {
          // console.log('OKEH', dataConvert);
          this.dialog = true
          this.resultsDataXml = dataConvert;
          addB2b(camelCaseKeysToUnderscore({ ...enqData, StatusEnq: '1', CompanycCategory: data.companycCategory, PurposeOfEnq: data.purposeOfEnq, IdMessage: data.idMessage, RoleInApplication: data.roleInApplication, DueDate: data.dueDate, ApplicationAmount: data.applicationAmount, ContractType: data.contractType, Currency: data.currency, OriginalAgreementNumber: data.originalAgreementNumber, OriginalAgreementDate: data.originalAgreementDate, XmlData: res.data }))
        } else {
          // console.log('FAILED', dataConvert);
          this.dialog = true
          this.resultsDataXml = dataConvert;
          addB2b(camelCaseKeysToUnderscore({ ...enqData, StatusEnq: '0', CompanycCategory: data.companycCategory, PurposeOfEnq: data.purposeOfEnq, IdMessage: data.idMessage, RoleInApplication: data.roleInApplication, DueDate: data.dueDate, ApplicationAmount: data.applicationAmount, ContractType: data.contractType, Currency: data.currency, OriginalAgreementNumber: data.originalAgreementNumber, OriginalAgreementDate: data.originalAgreementDate, XmlData: res.data }))
        }
      }

      return dataConvert;
    });
}

async function postMonitoringBySubject(data) {
  const getDataField = rowMonitoringBySubject(data);
  let dataRes = ax.post(`${url}/finance/Service.svc?singleWsdlQ`, getDataField).then(res => {
    return res;
  })
  return dataRes;
}

async function postMonitoringBySubjectCode() {
  const getDataField = rowMonitoringBySubjectCode();
  let dataRes = axios.post(`${url}/finance/Service.svc?singleWsdlQ`, getDataField).then(res => {
    return res;
  })
  return dataRes;
}

async function postPortfolioEnq() {
  const getDataField = rowPortfolioEnq();
  let dataRes = ax.post(`${url}/finance/Service.svc?singleWsdlQ`, getDataField).then(res => {
    return res;
  })
  return dataRes;
}


function camelCaseKeysToUnderscore(obj) {
  if (typeof (obj) != "object") return obj;

  for (var oldName in obj) {

    // Camel to underscore
    if (oldName == "NPWP") {
      var newName = 'npwp'
    }
    else {
      var newName = oldName.replace(/([A-Z])/g, function ($1) { return "_" + $1.toLowerCase(); }).replace('_', '');
    }

    // Only process if names are different
    if (newName != oldName) {
      // Check for the old property name to avoid a ReferenceError in strict mode.
      if (obj.hasOwnProperty(oldName)) {
        obj[newName] = obj[oldName];
        delete obj[oldName];
      }
    }


    // Recursion
    if (typeof (obj[newName]) == "object") {
      obj[newName] = camelCaseKeysToUnderscore(obj[newName]);
    }

  }
  return obj;
}

export default {
  list,
  filterExportLi,
  list_b2b,
  filterExportLc,
  postNewApplication,
  postNewApplicationB2b,
  postMonitoringBySubject,
  postMonitoringBySubjectCode,
  postPortfolioEnq,
};

